module.exports = __webpack_public_path__ + "static/media/NAFIL_logo_one_line.c56798a1.svg";